import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const MainScaffoldRoot = styled(Col)(
    ({ theme }) => css`
        padding: ${theme.spacing["6"]};
        row-gap: ${theme.spacing["6"]};
        flex: 1;
    `,
);
